import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get ward
export const getWard = createAsyncThunk("ward/getWard", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getWard({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all ward
export const getAllWard = createAsyncThunk("ward/getAllWard", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllWard();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("ward/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("ward/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("ward/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageWard({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get particular page
export const getWardById = createAsyncThunk("ward/getWardById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getWardById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create ward
export const createWard = createAsyncThunk("ward/createWard", async (param, { rejectWithValue }) => {
  const { location, number, isActive } = param;
  try {
    const body = JSON.stringify({ location, number, isActive });
    const { data } = await API.createWard(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateWard = createAsyncThunk("ward/updateWard", async (param, { rejectWithValue }) => {
  const { id, values } = param;
  const { location, number, isActive } = values;

  try {
    const body = JSON.stringify({ location, number, isActive });
    const { data } = await API.updateWard(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("ward/handleSearch", async (param, { rejectWithValue }) => {
  const { search, rowsPerPage } = param;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
